/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import Vue from 'vue';
import { render } from '../lib';
import { VmSlider } from '@vime/core';
import { define } from '../lib';
define('vm-slider', VmSlider);
export default Vue.extend({
    props: {
        step: {},
        min: {},
        max: {},
        value: {},
        valueText: {},
        label: {},
    },
    methods: {},
    render: render('vm-slider', ['vmValueChange', 'vmFocus', 'vmBlur']),
});
//# sourceMappingURL=Slider.js.map